
import React from 'react';
import TaskBoardSkeleton from './TaskBoardSkeleton';

interface TaskBoardLoadingProps {
  activeTaskCount?: number;
  completedTaskCount?: number;
  showCompletedExpanded?: boolean;
}

const TaskBoardLoading: React.FC<TaskBoardLoadingProps> = ({
  activeTaskCount,
  completedTaskCount,
  showCompletedExpanded
}) => {
  return (
    <TaskBoardSkeleton
      activeTaskCount={activeTaskCount}
      completedTaskCount={completedTaskCount}
      showCompletedExpanded={showCompletedExpanded}
    />
  );
};

export default TaskBoardLoading;
